import { PrismicFaqsService } from './prismic-faqs-service';

export const faqsService = new PrismicFaqsService();
